// animateUpNumbers.js

// Quadratic ease-out function
function easeOutQuad(t) {
    return t * (2 - t);
}

// Function to animate numbers
function animateNumber(element, start, end, duration, decimalPlaces, useFrenchFormat = false) {
    const startTime = performance.now();
    const formatter = new Intl.NumberFormat(useFrenchFormat ? 'fr-FR' : 'en-US', {
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces
    });
    
    // Store the original text pattern
    const originalText = element.textContent;
    
    function update() {
        const currentTime = performance.now();
        const elapsedTime = currentTime - startTime;
        const t = Math.min(elapsedTime / duration, 1);
        
        const progress = easeOutQuad(t);
        
        // Calculate current value
        const currentValue = start + (end - start) * progress;
        
        // Format the current value
        const formattedValue = formatter.format(currentValue);
        
        // Find the current displayed number and replace it
        const currentText = element.textContent;
        const currentNumberMatch = currentText.match(/([\d,]+(?:\.\d+)?)/);
        
        if (currentNumberMatch) {
            element.textContent = currentText.replace(currentNumberMatch[0], formattedValue);
        } else {
            element.textContent = originalText.replace('0', formattedValue);
        }
        
        if (progress < 1) {
            requestAnimationFrame(update);
        }
    }
    
    requestAnimationFrame(update);
}

// Function to extract the number and its decimal places from the string
function extractAndAnimateNumber(element, duration) {
    const text = element.textContent;
    // Updated regex to capture both period and comma as decimal separators
    const match = text.match(/([\d.,]+)/);
    
    if (match) {
        const numberStr = match[0];
        
        // Determine if comma is used as decimal separator (French style)
        const hasPeriod = numberStr.includes('.');
        const hasComma = numberStr.includes(',');
        const isCommaDecimal = hasComma && (!hasPeriod || numberStr.lastIndexOf(',') > numberStr.lastIndexOf('.'));
        
        // Calculate decimal places correctly based on the format
        const decimalPlaces = isCommaDecimal 
            ? (numberStr.split(',')[1] || '').length 
            : (numberStr.split('.')[1] || '').length;
        
        // Parse number correctly based on format
        let number;
        if (isCommaDecimal) {
            // Convert comma to period for parsing (7,4 -> 7.4)
            const fixedStr = numberStr.replace(/\./g, '').replace(',', '.');
            number = parseFloat(fixedStr);
        } else {
            // English style: remove comma thousand separators
            number = parseFloat(numberStr.replace(/,/g, ''));
        }
        
        //console.log('Original number string:', numberStr);
        //console.log('Parsed number value:', number);
        //console.log('Using French format:', isCommaDecimal);
        
        // Set initial value to 0 while preserving text structure
        const initialText = text.replace(numberStr, '0');
        element.textContent = initialText;
        
        // Start animation with the correct target number and format
        animateNumber(element, 0, number, duration, decimalPlaces, isCommaDecimal);
    }
}

// Function to initialize animation for all elements within each UL with class "about__facts-and-stats__facts"
function initAnimateUpNumbers(duration = 1000) {
    const ulElements = document.querySelectorAll('.about__facts-and-stats__facts');
    
    ulElements.forEach(ul => {
        const elements = ul.querySelectorAll('.animateUpNumbers');
        
        elements.forEach((element, index) => {
            // Delay calculation based on index (300ms per element)
            const delay = index * 100;
            
            // Create an intersection observer to check element visibility
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        // Start animation with delay if the element is visible
                        setTimeout(() => {
                            extractAndAnimateNumber(entry.target, duration);
                            // Stop observing the element after the animation starts
                            observer.unobserve(entry.target);
                        }, delay);
                    }
                });
            }, { threshold: 0.1 }); // Adjust the threshold as needed

            observer.observe(element);
        });
    });
}

// Automatically run the animation on document load
document.addEventListener('DOMContentLoaded', () => {
    initAnimateUpNumbers(1000); // Duration is 1 second by default
});
